// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__1jHaW","modalContent":"Modal_modalContent__iImdk","modalCross":"Modal_modalCross__5WFlQ"};